export default {
  setRequestListSelectedBid(state, payload) {
    state.requestListSelectedBid = payload;
  },
  setShopInfo(state, data){
    state.userShopInfo = data
  }
};